import React from "react";
import { Button, ButtonGroup } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const OutlinedButtonGroupHorz = () => {
  return (
    <>
      <PreviewAndEditor
        language="js"
        title={"Outlined primary button group"}
        value={
          '<ButtonGroup variant={"outlined"} aria-label="outlined primary button group">\n\t<Button>One</Button>\n\t<Button>Two</Button>\n\t<Button>Three</Button>\n</ButtonGroup>'
        }
      >
        <ButtonGroup
          variant={"outlined"}
          aria-label="outlined primary button group"
        >
          <Button>One</Button>
          <Button>Two</Button>
          <Button>Three</Button>
        </ButtonGroup>
      </PreviewAndEditor>
    </>
  );
};

export default OutlinedButtonGroupHorz;
